module.exports = __webpack_public_path__ + "img/sun_blue.b7e4218e.svg";